// import app from './app/app'
import sidebar from './sidebar/sidebar'
import chatBoard from './chatBoard/chatBoard'
import inboxPeople from './inboxPeople/inboxPeople'
import message from './message/message'
import imgPreview from './imgPreview/imgPreview'
import chatText from './chatText/chatText'
import avatar from './avatar/avatar'

export default [
    // app,
    sidebar,
    chatBoard,
    inboxPeople,
    message,
    imgPreview,
    chatText,
    avatar
]